import { render, staticRenderFns } from "./UserActivationForm.vue?vue&type=template&id=423d1968&scoped=true"
import script from "./UserActivationForm.vue?vue&type=script&lang=js"
export * from "./UserActivationForm.vue?vue&type=script&lang=js"
import style0 from "./UserActivationForm.vue?vue&type=style&index=0&id=423d1968&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423d1968",
  null
  
)

export default component.exports